import React, { useState } from 'react';
import { Container, Typography, Box, Button, Grid, Card, CardContent, Paper } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ManualHistorico from './ManualHistorico';
import ManualBanco from './ManualBanco';
import ManualArqAuxiliar from './ManualArqAuxiliar';
import LayoutArquivosDialog from './LayoutArquivosDialog';
import { ContactSupport, LibraryBooks, Description } from '@mui/icons-material';

function Suporte() {
    const theme = useTheme();
    const [selectedOption, setSelectedOption] = useState('');
    const [openManualHistorico, setOpenManualHistorico] = useState(false);
    const [openManualBanco, setOpenManualBanco] = useState(false);
    const [openManualArqAuxiliar, setOpenManualArqAuxiliar] = useState(false);
    const [openLayoutDialog, setOpenLayoutDialog] = useState(false);

    const handleButtonClick = (option) => {
        setSelectedOption(option);
        setOpenManualHistorico(option === 'Conciliação histórico');
        setOpenManualBanco(option === 'Conciliação bancária');
        setOpenManualArqAuxiliar(option === 'Conciliação auxiliar');
        setOpenLayoutDialog(option === 'Layout arquivos importação');
    };

    const handleCloseManualHistorico = () => setOpenManualHistorico(false);
    const handleCloseManualBanco = () => setOpenManualBanco(false);
    const handleCloseManualArqAuxiliar = () => setOpenManualArqAuxiliar(false);

    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Box sx={{ textAlign: 'center', mb: 5 }}>
                <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: theme.palette.primary.main }}>
                    Central de Ajuda
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                    Manuais, documentação e suporte técnico
                </Typography>
            </Box>

            <Grid container spacing={3} justifyContent="center">
                <Grid item xs={12} md={4}>
                    <Card sx={{ height: '100%', textAlign: 'center', p: 2, '&:hover': { boxShadow: 6 } }}>
                        <CardContent>
                            <LibraryBooks sx={{ fontSize: 40, color: theme.palette.secondary.main, mb: 2 }} />
                            <Typography variant="h6" gutterBottom>Manuais de Uso</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                Guias detalhados sobre como utilizar cada ferramenta de conciliação.
                            </Typography>
                            <Button
                                variant={selectedOption === 'Manual dos componentes' ? 'contained' : 'outlined'}
                                onClick={() => handleButtonClick('Manual dos componentes')}
                                fullWidth
                            >
                                Ver Manuais
                            </Button>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} md={4}>
                    <Card sx={{ height: '100%', textAlign: 'center', p: 2, '&:hover': { boxShadow: 6 } }}>
                        <CardContent>
                            <Description sx={{ fontSize: 40, color: theme.palette.info.main, mb: 2 }} />
                            <Typography variant="h6" gutterBottom>Layouts de Importação</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                Especificações dos arquivos suportados pelo sistema.
                            </Typography>
                            <Button
                                variant={selectedOption === 'Layout arquivos importação' ? 'contained' : 'outlined'}
                                onClick={() => handleButtonClick('Layout arquivos importação')}
                                fullWidth
                            >
                                Ver Layouts
                            </Button>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} md={4}>
                    <Card sx={{ height: '100%', textAlign: 'center', p: 2, '&:hover': { boxShadow: 6 } }}>
                        <CardContent>
                            <ContactSupport sx={{ fontSize: 40, color: theme.palette.error.main, mb: 2 }} />
                            <Typography variant="h6" gutterBottom>Suporte Técnico</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                Entre em contato com nossa equipe para ajuda personalizada.
                            </Typography>
                            <Button
                                variant={selectedOption === 'Suporte' ? 'contained' : 'outlined'}
                                onClick={() => handleButtonClick('Suporte')}
                                fullWidth
                            >
                                Contatar Suporte
                            </Button>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            {selectedOption === 'Manual dos componentes' && (
                <Paper elevation={3} sx={{ mt: 4, p: 3, backgroundColor: theme.palette.background.default }}>
                    <Typography variant="h6" gutterBottom>Selecione o Manual:</Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                            <Button variant="contained" fullWidth onClick={() => handleButtonClick('Conciliação histórico')}>
                                Histórico Contábil
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Button variant="contained" fullWidth onClick={() => handleButtonClick('Conciliação bancária')}>
                                Conciliação Bancária
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Button variant="contained" fullWidth onClick={() => handleButtonClick('Conciliação auxiliar')}>
                                Arquivo Auxiliar
                            </Button>
                        </Grid>
                    </Grid>
                </Paper>
            )}

            {selectedOption === 'Suporte' && (
                <Paper elevation={3} sx={{ mt: 4, p: 4, textAlign: 'center', backgroundColor: '#e3f2fd' }}>
                    <Typography variant="h5" gutterBottom color="primary">
                        Precisa de ajuda?
                    </Typography>
                    <Typography variant="body1">
                        Envie um email para nossa equipe de suporte:
                    </Typography>
                    <Typography variant="h6" sx={{ mt: 1, fontWeight: 'bold' }}>
                        guired@gmail.com
                    </Typography>
                </Paper>
            )}

            <ManualHistorico open={openManualHistorico} handleClose={handleCloseManualHistorico} />
            <ManualBanco open={openManualBanco} handleClose={handleCloseManualBanco} />
            <ManualArqAuxiliar open={openManualArqAuxiliar} handleClose={handleCloseManualArqAuxiliar} />
            <LayoutArquivosDialog open={openLayoutDialog} handleClose={() => setOpenLayoutDialog(false)} />
        </Container>
    );
}

export default Suporte;
